import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import SellYourMusic from "./pages/SellYourMusic";
import FreeMusicDistribution from "./pages/FreeMusicDistribution";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import AntiFraudPolicy from "./pages/AntiFraudPolicy";
import NotFound from "./pages/NotFound";
import { DASHBOARD_SIGNIN_URL } from "@/config/urls";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const SigninRedirect = () => {
  useEffect(() => {
    const queryString = window.location.search || "";
    const hash = window.location.hash || "";
    window.location.replace(`${DASHBOARD_SIGNIN_URL}${queryString}${hash}`);
  }, []);

  return null;
};

const AppRoutes = () => (
  <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Navigate to="/" replace />} />
      <Route path="/auth/signin" element={<SigninRedirect />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/sell-your-music" element={<SellYourMusic />} />
      <Route path="/free-music-distribution" element={<FreeMusicDistribution />} />
      <Route path="/terms-and-conditions" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/anti-fraud-policy" element={<AntiFraudPolicy />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </>
);

const App = () => {
  useEffect(() => {
    document.documentElement.classList.add("dark");

    const linkElement = document.createElement("link");
    linkElement.rel = "stylesheet";
    linkElement.href =
      "https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap";
    document.head.appendChild(linkElement);
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <div className="ophira-bg min-h-screen bg-ophira-dark text-white">
            <AppRoutes />
          </div>
        </TooltipProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
